import React from 'react'
import { Navigate } from 'react-router-dom'
import { getDecryptedUserFromCookie } from './utils/getCookie';


function ProtectedRoute({ children }) {
    const isAuthenticated = getDecryptedUserFromCookie("gta_mainstateuser")||"";
     const userLoggedIn = isAuthenticated && isAuthenticated?.emplyee_ID;

    return userLoggedIn ? children : <Navigate to="/login" />;
}
export default ProtectedRoute;